import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  onMounted,
  onUnmounted,
  withDefaults,
} from "../../../adapter-vue";
import {
  TUIStore,
  StoreName,
  TUITranslateService,
  IConversationModel,
} from "@tencentcloud/chat-uikit-engine";
import { TUIConstants, ExtensionInfo } from "@tencentcloud/tui-core";
// import { JoinGroupCard } from '@tencentcloud/call-uikit-vue';
import Icon from "../../common/Icon.vue";
import backSVG from "../../../assets/icon/back.svg";
import { isPC } from "../../../utils/env";
import TUIChatConfig from "../config";
import { json } from "stream/consumers";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    headerExtensionList: { default: () => [] }
  },
  emits: ["closeChat"],
  setup(__props: any, { emit: emits }) {

const props = __props as { headerExtensionList: ExtensionInfo[] }




const currentConversation = ref<IConversationModel>();
const currentConversationName = ref("");
const typingStatus = ref(false);
const groupID = ref("");
const isNotRoomChat = ref<boolean>(
  TUIChatConfig.getChatType() !== TUIConstants.TUIChat.TYPE.ROOM
);

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdated,
  });

  TUIStore.watch(StoreName.CHAT, {
    typingStatus: onTypingStatusUpdated,
  });
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdated,
  });

  TUIStore.unwatch(StoreName.CHAT, {
    typingStatus: onTypingStatusUpdated,
  });
});

const closeChat = (conversationID: string | undefined) => {
  emits("closeChat", conversationID);
};

const handleExtensions = (item: ExtensionInfo) => {
  item.listener.onClicked?.({ groupID: groupID.value });
};

function onCurrentConversationUpdated(conversation: IConversationModel) {
  currentConversation.value = conversation;
  groupID.value = currentConversation.value?.groupProfile?.groupID;
  currentConversationName.value = currentConversation?.value?.getShowName();
}

function onTypingStatusUpdated(status: boolean) {
  typingStatus.value = status;
  if (typingStatus.value) {
    currentConversationName.value =
      TUITranslateService.t("TUIChat.对方正在输入");
  } else {
    currentConversationName.value =
      currentConversation.value?.getShowName() || "";
  }
}

return { __sfc: true,props, emits, currentConversation, currentConversationName, typingStatus, groupID, isNotRoomChat, closeChat, handleExtensions, onCurrentConversationUpdated, onTypingStatusUpdated, Icon, backSVG, isPC }
}

})